module.exports = __webpack_public_path__ + "static/media/barangayan_cagayan_river.70fd36bc.jpg";